<template>
    <div class='mux-video-player-container' v-bind:class="{'embed-responsive-item': embedResponsiveItem}" ref="videoPlayerContainer">
      <video ref="videoPlayer"
        :id="this.playerDOMId" 
        class="video-js vjs-big-play-centered mux-attendee-video-player vjs-16-9"
        v-bind:class="vjsThemeClass"
        v-bind:poster="poster"
        playsinline
        :aria-label="'Video Player'"
      >
      </video>
    </div>
</template>

<script>
import videojs from '@mux/videojs-kit';
import '@mux/videojs-kit/dist/index.css';
// Base Video.js theme
import 'video.js/dist/video-js.css';
// ISSUES WITH MIX IN DEVELOP COMPILE
// import '@videojs/themes/dist/city/index.css';
// import '@videojs/themes/dist/fantasy/index.css';
// import '@videojs/themes/dist/forest/index.css';
// import '@videojs/themes/dist/sea/index.css';
import 'videojs-markers'
import 'videojs-markers/dist/videojs.markers.css';
const VIDEOJS_MARKER_STYLE = {
    fontSize: '16px',
    fontFamily: 'Arial',
    color: '#fff',
    backgroundColor: '#fff',
    // padding: '5px 10px',
    borderRadius: '5px',
    border: '1px solid #000'
}


export default {

  data: function () {
    return {
      metadataLoaded: false,
      markers: [],
      thresholdReached: false
    }
  },

  props: {
    eventAttendee: {
      type: Object,
      default: function () {
        return {}
      }
    },
    embedResponsiveItem: {
      type: Boolean,
      default: false
    },
    videoAsset: {
      type: Object,
      default: function () {
        return {}
      }
    },
    theme: {
      type: String,
      default: 'fantasy'
    },
    queuedConductor: {
      type: Boolean,
      default: false
    },
    customEventAttendeeId: {
      type: String|Number,
      default: null
    }
  },

  methods: {

    getPlayer () {
      return videojs(`#${this.playerDOMId}`)
    },

    // initVideoJSMarkers () {
    //   this.getPlayer().markers({
    //       markers: this.markers,
    //       markerStyle: VIDEOJS_MARKER_STYLE,
    //       markerTip: {
    //           display: true,
    //           text: function(marker) {
    //               return marker.text;
    //           },
    //           time: function(marker) {
    //               return marker.time;
    //           },
    //       },
    //   })

    //   if (this.metadataLoaded) this.getPlayer().markers.add(this.markers);
    // },

    getMuxPlayerOptions () {
      var muxDataPlugin = {
        plugins: {
          mux: {
            debug: false,
            data: {
              env_key: process.env.MIX_MUX_ENV_KEY, // required
              viewer_user_id: this.eventAttendeeId, // UNCOMMENT FOR LIVE
              video_id: 'muxAsset-' + this.muxAssetId, // ex: 'abcd123'
              video_title: this.videoTitle, // ex: 'My Great Video'
              custom_1: this.eventId,
              custom_2: this.videoAssetId,
              custom_3: this.customEventAttendeeId,
            },
          },
        },
      }

      return Object.assign({}, muxDataPlugin, this.videoAsset.videoOptions);
    },

    async createVideoAssetCompletion (timeThreshold) {
      let res;
      try {
        res = await fetch(`/api/v1/video-assets/${this.videoAssetId}/video-asset-completions`, {
          method: 'POST',
          headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json',
              'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').getAttribute('content')
          },
          body: JSON.stringify({
              view_duration: timeThreshold
          })
        })

        if (!res.ok) {
          throw new Error('Error creating video asset completion');
        }

        let data = await res.json();
        window.EventBus.$emit('video-asset-completion-created',this.videoAsset, data);
      } catch (error) {
        console.error('Error creating video asset completion', error);
      }
    },

    checkTimeThreshold() {

      if (!this.videoAsset.track_completion) {
        return
      }

      // check that track_completion_percentage is set and valid, to be valid it needs to be a number between 1 and 100
      if (this.videoAsset.track_completion_percentage < 1 || this.videoAsset.track_completion_percentage > 100) {
        console.error('Invalid track_completion_percentage value, must be a number between 1 and 100');
        return
      }

      var videoDuration = this.player.duration();

      var timeThreshold = (this.videoAsset.track_completion_percentage / 100) * videoDuration;

      // make sure the time threshhold is not less than 1 second
      if (timeThreshold < 1) {
        timeThreshold = 1;
      }
      // for 100% thresholds
      if (timeThreshold > 2) {
        timeThreshold = timeThreshold -1;
      }

      // make the time threshold a whole number
      timeThreshold = Math.floor(timeThreshold);

      // check that the video is at least the percentage of the video that needs to be watched
      if (!this.thresholdReached && this.player.currentTime() >= (timeThreshold - 1)) {
        this.thresholdReached = true;
        // this.$emit('thresholdReached', this.timeThreshold);
        console.log(`Threshold of ${timeThreshold} seconds reached!`);
        this.createVideoAssetCompletion(timeThreshold);

        window.EventBus.$emit('thresholdReached', timeThreshold);

        // You can add any other actions you want to perform here
      }
    },

    initMuxPlayer () {
      var player = videojs(`#${this.playerDOMId}`, this.getMuxPlayerOptions(), () => {
        this.player = player;
        this.metadataLoaded = true;
        if (this.videoAsset.chapters_vtt_url) {
          this.player.addRemoteTextTrack({
            kind: 'chapters', 
            src: this.videoAsset.chapters_vtt_url, 
            mode: 'showing', 
            language: 'en',
            default: 'default'
          })
        }
      });

      player.on('metadataloaded', () => {
        this.metadataLoaded = true;
      });

      player.on('timeupdate', () => {
        this.checkTimeThreshold();
      });
              
      player.textTracks().addEventListener('addtrack', (event) => {
        // listen for the track's cues to finish loading
        console.log("TRACK READY", event)
        event.track.on('loadeddata', () => {
          this.markers = track.cues_.map((cue) => {
            return {
              time: cue.startTime,
              text: cue.text
            }
          })
          // not quite working with videojs mux kit
          // this.initVideoJSMarkers()
        })
      })

      var playbackId = this.playbackId
      if (!playbackId) {
        console.log("NO PLAYBACK ID FOUND")
        return
      }
      var src = playbackId

      if (this.playbackPolicy === 'signed') {
        src = `${src}?token=${this.playbackToken}`
      }

      player.src({
        src: src,
        type: "video/mux"
      });

      player.on('enterpictureinpicture', function() {
        window.EventBus.$emit('enterpictureinpicture');
      }.bind(this));

      player.on('leavepictureinpicture', function() {
        window.EventBus.$emit('leavepictureinpicture');
      }.bind(this));

      player.on('error', function() {
        if (player.error() && player.error().hlsError && !player.error().hlsError.fatal) { 
          console.log('non-fatal error', player.error());
          player.error(null);
          return
        }
        console.log('fatal error', player.error());
      });
  
    },


    // was used previously for issues switching videos, vue keys seem to make not needed

    // addVideoPlayerToDOM () {
    //   var videoPlayerContainer = this.$refs.videoPlayerContainer
    //   var videoPlayer = document.createElement('video');
    //   videoPlayer.id = this.playerDOMId;
    //   videoPlayer.classList.add('video-js');
    //   videoPlayer.classList.add('vjs-big-play-centered');
    //   videoPlayer.classList.add('mux-attendee-video-player');
    //   videoPlayer.classList.add(`vjs-theme-${this.theme}`);
    //   videoPlayer.classList.add('vjs-16-9');
    //   videoPlayer.setAttribute('preload', 'auto')
    //   videoPlayer.setAttribute('fluid', true)
    //   videoPlayer.setAttribute('controls', true)
    //   videoPlayerContainer.appendChild(videoPlayer);
    // }    
  },

  computed: {

    poster () {
      if (this.videoAsset.custom_poster_image_enabled && this.videoAsset.poster_image_url) {
        return this.videoAsset.poster_image_url
      }
      else if (this.videoAsset.mux_asset && this.videoAsset.mux_asset.poster){
        return this.videoAsset.mux_asset.poster
      }
      else {
        return null;
      }
    },

    videoAssetCompleted () {
      return this.videoAsset && this.videoAsset.video_asset_completions && this.videoAsset.video_asset_completions.length
    },

    vjsThemeClass () {
      return `vjs-theme-${this.theme}`
    },

    playerDOMId () {
      return `player-${Math.floor(Math.random() * 1000000)}`
    },

    playbackIds () {
      return this.videoAsset 
        && this.videoAsset.mux_asset 
        && this.videoAsset.mux_asset.playback_ids
        && JSON.parse(this.videoAsset.mux_asset.playback_ids);
    },

    playbackId () {
      return this.videoAsset 
        && this.videoAsset.mux_asset 
        && this.videoAsset.mux_asset.playback_id
    },

    playbackToken () {
      return this.videoAsset 
        && this.videoAsset.mux_asset 
        && this.videoAsset.mux_asset.playback_token
    },

    playbackPolicy () {
      return this.videoAsset 
        && this.videoAsset.mux_asset 
        && this.videoAsset.mux_asset.playback_policy
    },
    
    eventAttendeeId () {
      return this.eventAttendee && this.eventAttendee.id
    },
    eventId () {
      return this.eventAttendee && this.eventAttendee.event_id;
    },
    videoAssetId () {
      return this.videoAsset && this.videoAsset.id;
    },
    
    videoTitle () {
      return this.videoAsset && this.videoAsset.title
    },

    muxAssetId () {
      return this.videoAsset && this.videoAsset.mux_asset && this.videoAsset.mux_asset.id
    },

  },

  beforeMount () {
    this.$nextTick(() => {
      this.initMuxPlayer();
    });
  },

  activated () {
    // this.$nextTick(() => {
    //   this.initMuxPlayer();
    // });
  },

  beforeDestroy () {
    if (this.getPlayer() && this.getPlayer().isInPictureInPicture()) {
      this.getPlayer().exitPictureInPicture();
    }
    this.getPlayer().dispose();
  },

}
</script>

<style>
  .mux-video-player-container::-webkit-scrollbar,
  .mux-video-player-container *::-webkit-scrollbar {
    display: none;
    -ms-overflow-style: none;  /* IE and Edge */
    scrollbar-width: none;  /* Firefox */
  }
  
  .mux-video-player-container > .mux-attendee-video-player {
    height: 100%;
    width: 100%;
  }

  .mux-video-player-container > .mux-video-player-container {
    display: none;
  }

</style>